module.exports = __webpack_public_path__ + "static/img/checkmark-red.de9a310.png";